import React from "react";
import "./DisclosureIcon.css";

export default function DisclosureIcon() {
  return <span className="disclosure-icon" aria-hidden="true" />;
}
